import type { ButtonHTMLAttributesWithRef } from 'types';

type Props = Omit<
	ButtonHTMLAttributesWithRef<HTMLButtonElement>,
	'aria-disabled'
>;

/** Unstyled button that handles accessible disabling. */
export default function PlainButton({
	children,
	disabled,
	onClick,
	ref,
	type = 'button',
	...attrs
}: Props) {
	return (
		<button
			ref={ref}
			// Lint rule doesn't understand that the type only allows valid values.
			// oxlint-disable-next-line react/button-has-type
			type={type}
			onClick={disabled ? undefined : onClick}
			aria-disabled={disabled ? 'true' : undefined}
			{...attrs}
		>
			{children}
		</button>
	);
}
PlainButton.displayName = 'PlainButton';
